import { ScrollWrapper } from 'legacy/lut/components/widgets/public/tabs/ScrollWrapper'
import React from 'react'

import { ITabButtonsProps, TabButtons } from 'core-components/library/tabButtons'

import styles from './ScrollTabs.module.scss'

export const ScrollTabs = (props: ITabButtonsProps) => {
  return (
    <ScrollWrapper>
      <TabButtons
        {...props}
        classes={{
          root: styles.tabs,
          button: styles.tab,
          buttonActive: styles.tabActive,
        }}
      />
    </ScrollWrapper>
  )
}
